export interface NameFileId {
    m?: number;
    f?: number;
}

export interface FirstnameIndices {
    [keyName: string]: NameFileId;
}

export interface LastnameIndices {
    [keyName: string]: number;
}

export type NameIndices = FirstnameIndices | LastnameIndices;

export interface Municipality {
    name: {
        [keyLang: string]: string;
    };
    population: number;
    mainLanguageGroup: string;
}

export interface Municipalities {
    [keyId: string]: Municipality;
}

export interface MunicipalityNameValues {
    [keyId: string]: number;
}

export interface MunicipalityNameValuesMerged {
    [keyId: string]: MunicipalityNameValues | boolean;
}

export type MunicipalityNameData = MunicipalityNameValues | MunicipalityNameValuesMerged;

export interface NewbornEntry {
    [keyName: string]: number;
}

export interface WordCloudEntry {
    text: string;
    value: number;
    sex?: Sex;
}

export interface RankingEntry {
    name: string;
    count: number;
    avgAge?: number;
}

export interface RankingData {
    m: RankingEntry[];
    f: RankingEntry[];
}

export interface NewbornRankingData {
    [keyYear: string]: {
        [keyLang: string]: RankingData;
    }
}

export interface FirstnameRankingData {
    [keyLang: string]: RankingData;
}

export interface LastnameRankingData {
    [keyLang: string]: RankingEntry[];
}

export enum NameType {
    Firstname,
    Lastname
}

export enum Sex {
    Male = "m",
    Female = "f"
}

export enum SexSelection {
    All = "a",
    Male = "m",
    Female = "f"
}

export enum LanguageGroup {
    All = "all",
    German = "de",
    Italian = "it",
    Ladin = "ld"
}

export enum DownloadType {
    Firstnames = "firstnames",
    Lastnames = "lastnames",
    Newborns = "newborns",
}

export interface Person {
    name: string;
    sex?: Sex;
}

export interface PersonFileInfo {
    fileId: number;
    person: Person;
}

export type RGB = `rgb(${number}, ${number}, ${number})`;
export type RGBA = `rgba(${number}, ${number}, ${number}, ${number})`;
